var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutdoors2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.268 19.834c5.68 2.068 10.222 1.19 13.157-1.995 2.964-3.215 4.09-8.583 3.345-14.91a.852.852 0 00-.745-.746c-6.328-.745-11.696.381-14.911 3.345-3.209 2.957-4.076 7.546-1.947 13.286L2.22 20.76a.75.75 0 101.06 1.06l1.988-1.987zm1.18-1.18l4.802-4.802h3.5a.75.75 0 000-1.5h-2l3.612-3.612a.75.75 0 10-1.06-1.06l-9.96 9.958c-1.68-5.021-.73-8.686 1.789-11.007 2.676-2.467 7.322-3.614 13.206-3.015.6 5.884-.548 10.53-3.015 13.206-2.3 2.497-5.921 3.451-10.875 1.833z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoors2);
export default __webpack_public_path__ + "static/media/Outdoors2.f1e70dfd629c5f3360dab4387b1d656e.svg";
export { ForwardRef as ReactComponent };